import { BotMessage, Button, Carousel, Menu} from '../../types'
import { createQuickReply, createSlide } from './helpers'
import { splitMessages } from '../motion/helpers'
import { getAppInstanceId } from '../../../../helpers/getAppInstanceId'
import queryString from 'query-string'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'

export const makeGetBotResponse = ({ fetchAnswer }) => async (question, global, module) => {
  const answer = await fetchAnswer(question, global, module)
  return transformMsg(answer)
}

export const makeGetSession = config => async () => {
  const { sessionUrl, userId, getSessionData, setSessionData, botId } = config
  const sessionKey = `${userId}_${botId}`
  const res = await fetch(`${sessionUrl}/${sessionKey}`)
  if (res.status === 404) {
    const createdSession = await fetch(`${ sessionUrl }/${sessionKey}`, { method: 'post' })
    const sessionData = await createdSession.json()
    setSessionData(sessionData)
    return sessionData
  }

  const { sessionId } = await res.json()
  const { sessionToken } = getSessionData()
  return { sessionId, sessionToken }
}

export const makeFetchAnswer = config => async (question, global = false, module) => {
  const { botUrl, botId, getSession } = config
  const { sessionId, sessionToken } = await getSession()

  const query = queryString.stringify({
    module,
    global: global ? '1' : undefined,
    reply: question,
    id: botId,
    session: sessionId,
    token: sessionToken,
    app_instance_id: getAppInstanceId(),
  })

  const response = await fetch(`${botUrl}/bot?${query}`)
  const json = await response.json()
  if (!response.ok) {
    throw new Error(json.message)
  }

  return json
}

export const makeGetRawHistory = ({ getSession, historyUrl }) => async () => {
  const { sessionId, sessionToken } = await getSession()

  const url = `${historyUrl}?session=${sessionId}&token=${sessionToken}`

  try {
    const res = await fetch(url)
    if (res.status === 404) { return [] }

    const data = await res.json()

    if (!res.ok) {
      throw new Error(data.message)
    }
    return data

  } catch(e){
    console.log(e)
    return []
  }
}

export const makeGetHistory = ({ getRawHistory }) => async () => {
  const data = await getRawHistory()
  return data.map(item => {
    if (item.payload.botMessage) {
      return {
        botMessage: transformMsg(item.payload.botMessage),
        timestamp: item.timestamp
      }
    }
    return {
      userMessage: item.payload.userMessage,
      timestamp: item.timestamp
    }
  })
}

export const makeGetConversationId = ({ getSession, conversationIdUrl }) => async () => {
  const { sessionId } = await getSession()
  const url = `${conversationIdUrl}/${sessionId}`

  const res = await fetch(url)
  const data = await res.json()

  if (!res.ok) {
    throw new Error(data.message)
  }

  return data
}


const transformMsg = resp => {
  let result = new BotMessage()
  // // ANSWERS
  result.messages = splitMessages(resp.output)

  // // QUICK REPLIES
  result.quickReplies = resp.quickReplies ?
    resp.quickReplies.map(createQuickReply)
    : []

  // // CAROUSEL
  const slides = resp.cards && resp.cards.map(createSlide)
  result.carousel = !isEmpty(slides) && new Carousel(slides)


  // THEME
  if (resp.theme) {
    result.theme = resp.theme
  }

  // STYLES
  if (resp.styles) {
    result.styles = resp.styles
  }

  // MENU
  if (resp.menu) {
    result.menu = new Menu()
    result.menu.buttons = map(resp.menu.buttons, b => new Button(b))
  }

  // Sender Placeholder
  if (resp.prompt) {
    result.senderPlaceHolder = resp.prompt
  }


  if (resp.disableInput) {
    result.forceReply = true
  }

  if (resp.blink) {
    result.blink = true
  }

  if (resp.blinkColor) {
    result.blinkColor = resp.blinkColor
  }

  if (resp.dropdownInput) {
    result.dropdownInput = true
  }

  if (resp.dropdownOptions) {
    result.dropdownOptions = resp.dropdownOptions
  }

  if (resp.dateInput) {
    result.dateInput = true
  }

  if (resp.waitFor) {
    result.waitFor = resp.waitFor
  }

  if (resp.module) {
    result.module = resp.module
  }

  if (resp.dbNav) {
    result.dbNav = resp.dbNav
  }

  if (resp.dbNavTitle) {
    result.dbNavTitle = resp.dbNavTitle
  }

  if (resp.toc) {
    result.toc = new Menu()
    result.toc.buttons = map(resp.toc.buttons, b => new Button(b))
  }

  if (resp.conversationId) {
    result.conversationId = resp.conversationId
  }

  if (resp.moduleTitle) {
    result.moduleTitle = resp.moduleTitle
  }

  return result
}

export const setSessionData = ({ sessionId, sessionToken }) => {
  localStorage.setItem('sessionId', sessionId)
  localStorage.setItem('sessionToken', sessionToken)
}

export const getSessionData = () => ({
  sessionId: localStorage.getItem('sessionId'),
  sessionToken: localStorage.getItem('sessionToken')
})




// WEBPACK FOOTER //
// ./src/App/services/adapters/botapi/shared.js